<template>
    <div class="status-indicator" :class="isAvailable ? 'available-status' : 'unavailable-status' "></div>
</template>

<script>
export default {
    name: 'AvailabilityIndicator',
    props: {
        isAvailable: {
            type: Boolean,
            default: false
        }
    }
};
</script>